import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Multiselect } from 'react-widgets';
import ReportComponent from '../../utils/ReportComponent/ReportComponent';
import typeOf from '../../helpers/typeOf';

const Default = ({ segment: propSegment, values: propValues, onChange: propOnChange }) => {
    const [segment, setSegment] = useState(propSegment);
    const [values, setValues] = useState([]);
    const [list, setList] = useState([]);

    const getList = useCallback((segment) => {
        const metricParams = ReportComponent.getParams({ key: segment, metricKey: 'GroupBy' });
        return metricParams.values || [];
    }, []);

    const parseData = useCallback((values) => {
        if (!values || !Array.isArray(values)) return [];
        
        if (values.length && !typeOf.isObject(values[0])) {
            return values.map((item) => ({ value: item, title: item }));
        } else if (typeOf.isObject(values[0]) && !values[0].title) {
            return values.map((item) => ({ value: item.value, title: item.value }));
        }

        return values;
    }, []);

    useEffect(() => {
        setSegment(propSegment);
        setValues(parseData(propValues || []));
        setList(getList(propSegment));
    }, [propSegment, propValues, parseData, getList]);

    const onChange = useCallback((newValues) => {
        setValues(newValues);
        if (propOnChange) {
            propOnChange(newValues);
        }
    }, [propOnChange]);

    return (
        <Multiselect
            value={Array.isArray(values) ? values : []}
            data={Array.isArray(list) ? list : []}
            onChange={onChange}
            textField="title"
            dataKey="value"
            filter="startsWith"
            placeholder="Select values..."
        />
    );
};

Default.propTypes = {
    segment: PropTypes.string,
    values: PropTypes.array,
    onChange: PropTypes.func
};

Default.defaultProps = {
    segment: '',
    values: [],
    onChange: () => {}
};

export default Default;